import { Component, OnInit, Inject } from '@angular/core';
import { Payment } from 'src/app/stores/payment.store';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PrintService } from 'src/app/services/print.service';
import { Report } from 'src/app/stores/report.store';
import { SCHOOL } from 'src/app/dummy/config';

@Component({
  selector: 'app-report-receipt-summary-dialog',
  templateUrl: './report-receipt-summary-dialog.component.html',
  styleUrls: ['./report-receipt-summary-dialog.component.scss']
})
export class ReportReceiptSummaryDialogComponent implements OnInit {
  school=SCHOOL

  constructor(
    public dialogRef: MatDialogRef<ReportReceiptSummaryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public store: Report,
    private ps: PrintService,
  ) { }

  ngOnInit() {
    this.store.fetchSummary(this.data);
  }

  print() {
    this.ps.print("#printD", "a4");
  }

}
